import { render, staticRenderFns } from "./TaxStandardAddEdit.vue?vue&type=template&id=726557ed"
import script from "./TaxStandardAddEdit.vue?vue&type=script&lang=js"
export * from "./TaxStandardAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports